<ng-container *ngIf="option?.subtitle && resources?.length > 1">
  <div class="reason-container">
    <span>{{ option.subtitle }}</span>
    <ng-container *ngTemplateOutlet="resourcesList"></ng-container>
  </div>
</ng-container>

<ng-template #resourcesList>
  <div *ngFor="let resource of resources; let i = index" class="resource-container">
    <u-checkbox [checked]="false" [binary]="true" [isNoColor]="true" (click)="onClickResource(resource)"> </u-checkbox>
    <u-icon *ngIf="intent !== 'People'" class="reference-number" [model]="{ type: 'font-icon', value: 'icon-number-' + (i + 1) }"></u-icon>
    <u-icon
      class="resource-icon"
      [model]="{ type: 'img', value: resource.resource?.appId === 'wiki' ? resource.view?.iconOverlay : resource.view?.icon }"
    ></u-icon>
    <span>{{ resource.view?.title?.text }}</span>
  </div>
</ng-template>
